module.exports = __webpack_public_path__ + "static/media/Raticate_gaussian2.78242c83.png";